import * as bus from 'framebus';
import {newLogger} from "./logger";

/**
 * System-wide event class
 */
export class GlobalEvent {
	/**
	 * Event constructor
	 * @param {string} name Event name
	 */
	constructor(name) {
		this._name = name;
	}

	/**
	 * Trigger this event
	 * @param data The data to give to subscribers
	 */
	trigger(data = null) {
		newLogger(this.toString()).log('trigger', data);
		bus.trigger(this._name, data);
	}

	/**
	 * Subscribe to this event
	 * @param {function} handler Function that accepts event data as first argument
	 * @return {Subscription}
	 */
	on(handler) {
		return this._getSubscription(handler).on();
	}

	/**
	 * Unsubscribe from this event
	 * @param {function} handler The same function that was passed to {@link on} method
	 */
	off (handler) {
		this._getSubscription(handler).off();
	}

	toString() {
		return `GlobalEvent/${this._name}`;
	}

	/**
	 * Creates subscription instance. To actually subscribe, call on() method.
	 * @param {function} handler Function that accepts event data as first argument
	 * @return {Subscription}
	 */
	_getSubscription(handler) {
		return new Subscription(this._name, handler);
	}
}

class Subscription {
	_name;
	_handler;

	constructor(name, handler) {
		this._name = name;
		this._handler = handler;
	}

	/**
	 * Attach the subscription to bus
	 * @return {Subscription} This instance
	 */
	on() {
		bus.on(this._name, this._handler);
		return this;
	}

	/**
	 * Cancel this subscription
	 * @return {Subscription} This instance
	 */
	off() {
		bus.off(this._name, this._handler);
		return this;
	}
}



// WEBPACK FOOTER //
// ./core/utils/event.js